import { ECompareType, EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../types/requestForm';
import { ETopic } from '../../../types/topic';
import { createFields } from './utils/createFields';
import { createValidation } from './utils/createValidation';
import { NEXT_BUTTON_TEXT } from '../../../constants/requestForm/buttonText';
import { createField } from './utils/createField';
var FIELDS = [createField(EFormFieldsNames.Topic, {
  autoSubmit: true
})];
export var TOPIC_STEP = {
  code: EStepCodes.Topic,
  question: {
    code: EQuestionCodes.Topic,
    title: 'Напишите нам',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: NEXT_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.Moderation]
    }],
    nextStepCode: EStepCodes.ModerationInitial
  }, {
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.ComplaintFromOwnerProperty]
    }],
    nextStepCode: EStepCodes.ComplaintFromOwnerProperty
  }, {
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.ComplaintFromOwnerPhoto]
    }],
    nextStepCode: EStepCodes.ComplaintFromOwnerPhoto
  }, {
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.OfferComplaint]
    }],
    nextStepCode: EStepCodes.OfferComplaintInitial
  }, {
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.Login]
    }],
    nextStepCode: EStepCodes.Login
  }, {
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.PartnerRewards]
    }],
    nextStepCode: EStepCodes.PartnerRewardsInitial
  }, {
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.XmlUnloading]
    }],
    nextStepCode: EStepCodes.XmlUnloading
  }, {
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.VillageRequest]
    }],
    nextStepCode: EStepCodes.VillageRequest
  }, {
    conditions: [{
      answerField: EFormFieldsNames.Topic,
      compareType: ECompareType.Eq,
      value: [ETopic.CountrysideBuildersProjectRequest]
    }],
    nextStepCode: EStepCodes.CountrysideBuildersProjectRequest
  }, {
    conditions: [],
    nextStepCode: EStepCodes.CommonForm
  }]
};